import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { RunsPage } from './pages/RunsPage';
import { RunDetailPage } from './pages/RunDetailPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { OnboardeurPage } from './pages/agents/OnboardeurPage';
import { EcheancierPage } from './pages/agents/EcheancierPage';
import { ComptablePage } from './pages/agents/ComptablePage';
import { FacturierPage } from './pages/agents/FacturierPage';
import { RecouvreurPage } from './pages/agents/RecouvreurPage';
import { RapprocheurPage } from './pages/agents/RapprocheurPage';
import { FiscalistePage } from './pages/agents/FiscalistePage';
import { ClotureurPage } from './pages/agents/ClotureurPage';
import { LiassierPage } from './pages/agents/LiassierPage';
import { ControleurDgiPage } from './pages/agents/ControleurDgiPage';
import { VeilleurJortPage } from './pages/agents/VeilleurJortPage';
import { OptimisateurPage } from './pages/agents/OptimisateurPage';
import { CacOectPage } from './pages/agents/CacOectPage';
import { DrhCnssPage } from './pages/agents/DrhCnssPage';
import { JuristeRnePage } from './pages/agents/JuristeRnePage';
import { TresorierPage } from './pages/agents/TresorierPage';
import { AgentJsonInvokePage } from './pages/agents/AgentJsonInvokePage';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminSettingsPage } from './pages/admin/AdminSettingsPage';
import { AdminFirmsPage } from './pages/admin/AdminFirmsPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';

export function App() {
  return (
    <Routes>
      {/* Pages publiques (sans Layout authentifié) */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />

      {/* Routes admin (protégées par leur propre token) */}
      <Route element={<Layout />}>
        <Route path="/admin/settings" element={<AdminSettingsPage />} />
        <Route path="/admin/firms" element={<AdminFirmsPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
      </Route>

      {/* Routes utilisateur — protégées par ProtectedRoute */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/runs" element={<RunsPage />} />
          <Route path="/runs/:runId" element={<RunDetailPage />} />
          <Route path="/companies" element={<CompaniesPage />} />

          {/* Phase 1 */}
          <Route path="/agents/onboardeur" element={<OnboardeurPage />} />
          <Route path="/agents/echeancier" element={<EcheancierPage />} />
          <Route path="/agents/comptable" element={<ComptablePage />} />
          <Route path="/agents/facturier" element={<FacturierPage />} />
          <Route path="/agents/recouvreur" element={<RecouvreurPage />} />

          {/* Phase 2 */}
          <Route path="/agents/rapprocheur" element={<RapprocheurPage />} />
          <Route path="/agents/fiscaliste" element={<FiscalistePage />} />
          <Route path="/agents/clotureur" element={<ClotureurPage />} />
          <Route path="/agents/liassier" element={<LiassierPage />} />

          {/* Phase 3 — Opus */}
          <Route path="/agents/controleur_dgi" element={<ControleurDgiPage />} />
          <Route path="/agents/veilleur_jort" element={<VeilleurJortPage />} />
          <Route path="/agents/optimisateur" element={<OptimisateurPage />} />

          {/* Phase 4 */}
          <Route path="/agents/cac_oect" element={<CacOectPage />} />
          <Route path="/agents/drh_cnss" element={<DrhCnssPage />} />
          <Route path="/agents/juriste_rne" element={<JuristeRnePage />} />
          <Route path="/agents/tresorier" element={<TresorierPage />} />

          {/* Fallback JSON (debug uniquement) */}
          <Route path="/agents/:agentName" element={<AgentJsonInvokePage />} />
        </Route>
      </Route>
    </Routes>
  );
}
